export default defineNuxtPlugin(() => {
  const authCookie = useCookie('auth_token')
  const config = useRuntimeConfig()

  const $authFetch = $fetch.create({
    baseURL: config.public.apiBase as string,

    async onRequest({ options }) {
      logger.debug('[Fetch.Plugin] onRequest')

      const token = useAuth().getToken()
      logger.debug('[Fetch.Plugin] Request:', {
        hasAuthHeader: !!token,
        hasAuthCookie: !!authCookie.value,
        isServer: import.meta.server
      })

      if (token) {
        logger.debug('[Fetch.Plugin] Setting Authorization header:', { token })
        ;(options.headers as Headers).set('Authorization', `Bearer ${token}`)
      }
    },

    onResponseError({ response }) {
      logger.debug('[Fetch.Plugin] Response Error:', {
        status: response.status,
        statusText: response.statusText
      })

      if (import.meta.client && (response.status === 401 || response.status === 498)) {
        const { clearToken } = useAuth()
        const authUser = useAuthUser()
        clearToken()
        authUser.value = null
        navigateTo('/signin')
      }
    }
  })

  return {
    provide: {
      apiFetch: $authFetch
    }
  }
})
